import { directus, Edizione } from '../../../directus'
import { readItems } from '@directus/sdk';
import { formatDate } from "@angular/common";
import { environment } from '../../environments/environment';
import { IscrizioneObj } from './iscrizione-obj';
import { NgZone } from '@angular/core';

export class EdizioneObj implements Edizione{

  id: number = -1;
  status: number = 0;
  nome: string = '';
  descrizione: string = '';
  inizio!: Date;
  fine!: Date;
  progetto: number = 0;
  badge!: string;
  b_font_size: number = -1;
  bw: number = -1;
  bh: number = -1;
  tx: number= -1;
  ty: number = -1;
  qrcode_w: number = -1;
  qrcode_h: number = -1;
  qrcode_x: number = -1;
  qrcode_y: number = -1;

  iscritti: IscrizioneObj[] | undefined;
  confermati: number = 0;
  presenti: number = 0;
  iscrizioni: number = 0;

  constructor(source: Partial<Edizione>) {
    if (source) {
      Object.assign(this, source);
      //this.getAllIscrizioni();
    } else {
      this.b_font_size = environment.b_font_size;
      this.bw = environment.bw;
      this.bh = environment.bh;
      this.tx = environment.tx;
      this.ty = environment.ty;
      this.qrcode_w = environment.qrcode_w;
      this.qrcode_h = environment.qrcode_h;
      this.qrcode_x = environment.qrcode_x;
      this.qrcode_y = environment.qrcode_y;
    }
  }

  async getAllIscrizioni(): Promise<IscrizioneObj[]> {
    const self = this;
    try {
      this.iscritti = await directus
        .request<IscrizioneObj[]>(readItems("iscrizioni", {
          fields: ["id", "status", "nome", "cognome", "azienda", "email", "profilo", "edizione", "confermata", "presenza", "orario", "date_created", "date_updated"],
          sort: ['date_created'], //Sort by sort field and creation date descending
        }));

      this.analizzaIscrizioni();

      return this.iscritti;

    } catch (error: any) {
      error = JSON.parse(JSON.stringify(error));
      if (error && error != undefined) {
        if (error.errors[0].extensions.code === 'FORBIDDEN') {
          //self.app.logOut();
        }
      }
      console.error(error);
      return this.iscritti;
    }
  }

  analizzaIscrizioni() {
    if (!this.iscritti || this.iscritti == undefined)
      return;

    console.log(this.iscritti)
    let self = this;
    this.iscrizioni = this.iscritti.length;

    this.iscritti.forEach(async (_iscritto: IscrizioneObj) => {
      if (_iscritto && _iscritto != undefined) {
          if (_iscritto.confermata == 1) {
            self.confermati++;
          }
          if (_iscritto.presenza == 1) {
            self.presenti++;
          }
      }
    });
  }

  objToEdizione(_ed: EdizioneObj):Edizione {

    const _edizione = {
      id: _ed.id,
      status: _ed.status,
      nome: _ed.nome,
      descrizione: _ed.descrizione,
      inizio: _ed.inizio,
      fine: _ed.fine,
      progetto: _ed.progetto,
      badge: _ed.badge,
      b_font_size: _ed.b_font_size,
      bw: _ed.bw,
      bh: _ed.bh,
      tx: _ed.tx,
      ty: _ed.ty,
      qrcode_w: _ed.qrcode_w,
      qrcode_h: _ed.qrcode_h,
      qrcode_x: _ed.qrcode_x,
      qrcode_y: _ed.qrcode_y
    } // extract the property `a` and keep the other properties in `otherProperties`

    return _edizione;
  }
  getEditionDate() {
    if ( this.inizio && this.fine) {
      return formatDate(this.inizio, 'M/d/yy, h:mm a'	, 'it-IT', 'Europe-rome') + ' - ' + formatDate(this.fine, 'M/d/yy, h:mm a'	, 'it-IT', 'Europe-rome');
    }
    return 'nodate';
  }
}

